import { Navigate } from "react-router-dom";
import { getSession } from "../service/auth";

/**
 * Wraps private routes. Redirects to /login if no session exists.
 */
export default function ProtectedRoute({ children }) {
  const session = getSession();
  if (!session || !session.email) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
